<template>
    <div class="toolbox-content">
        <h3>Neuen Import starten</h3>
        <div class="formItem vue-dropzone">
            <ul class="entry-list dropzone dropzone-previews" ref="dropZonePreviewContainer">
            </ul>
        </div>
        <div class="droparea dz-clickable" ref="dropZoneElement">
            <i class="icon-plus"></i>
            Dateien wählen oder hier ablegen
        </div>
      <div class="empty-state">
        Wählen Sie die 3 Dateien (.shp, .dbf, .shx) eines Shapesfiles in der Projektion EPSG:25832 aus.
      </div>
    </div>
</template>

<script>
  import Dropzone from 'dropzone'
  import _ from 'lodash'

  Dropzone.autoDiscover = false
  export default {
    props: {
      value: {
        type: Object,
        required: true
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        neededExtensions: ['.shp', '.dbf', '.shx'],
        dropzone: null,
        addRemoveLinks: true,
        dropzoneSettings: {
          acceptedFiles: '.shp,.shx,.dbf',
          uploadMultiple: true,
          autoProcessQueue: false,
          clickable: true,
          parallelUploads: 3,
          // maxFiles: 3,
          previewTemplate: '<li class="icon-document"><a href="#" title="#" data-dz-remove class="icon-trash-small"></a><i data-dz-name></i></li>'
          // previewTemplate: '<div class="img"><img data-dz-thumbnail /><span><button data-dz-remove class="btn-icon-only icon-trash-small"></button><i data-dz-name></i></span></div>'
        }
      }
    },
    mounted () {
      if (this.value.getDropzone()) {
        let files = this.value.getDropzone().files
        this.value.getDropzone().destroy()
        this.value.alreadyUploaded = false
        this.dropzone = new Dropzone(this.$refs.dropZoneElement, this.getDropZoneSettings)

        for (let i = 0; i < files.length; i++) {
          this.dropzone.addFile(files[i])
          // this.dropzone.files[i].previewElement = Dropzone.createElement(this.dropzoneSettings.previewTemplate)
          // this.dropzone.emit('addedfile', this.value.dropZoneFiles[i])
          // this.dropzone.emit('complete', this.value.dropZoneFiles[i])
        }
        this.dropzone.removeEventListeners()
      } else {
        this.dropzone = new Dropzone(this.$refs.dropZoneElement, this.getDropZoneSettings)
      }

      this.dropzone.on('addedfile', (file) => {
        if (file.ignoreCustomLogic === true) {
          file.ignoreCustomLogic = false
          return
        }
        if (!this.checkIfFileIsValid(file)) {
          this.dropzone.removeFile(file)
        }
      })

      this.dropzone.on('maxfilesreached', (...args) => {
        this.dropzone.removeEventListeners()
      })

      this.dropzone.on('removedfile', (file) => {
        if (this.dropzone.files.length < 3) {
          this.dropzone.setupEventListeners()
        }
      })

      this.value.setDropzone(this.dropzone)
    },
    beforeDestroy () {
      // this.dropzone.destroy()
    },
    methods: {
      checkIfFileIsValid (file) {
        let availableExtension = _.clone(this.neededExtensions)

        // geht alle files durch und prüft deren file-extension
        // von jedem typ sollte es nur eine datei geben
        for (let i = 0; i < this.dropzone.files.length; i++) {
          for (let k = 0; k < availableExtension.length; k++) {
            if (file.name === this.dropzone.files[i].name && this.dropzone.files[i].status === 'added') {
              continue
            }
            if (_.endsWith(this.dropzone.files[i].name, availableExtension[k])) {
              availableExtension.splice(k, 1)
            }
          }
        }

        if (availableExtension.length > 0) {
          // we still got room
          for (let k = 0; k < availableExtension.length; k++) {
            if (_.endsWith(file.name, availableExtension[k])) {
              availableExtension.splice(k, 1)

              if (availableExtension.length === 0) {
                // start upload, we got all files
                if (this.value.step === 1) {
                  this.goNext()
                }
              }

              return true
            }
          }
        }

        if (availableExtension.length === 0) {
          // start upload, we got all files
          if (this.value.step === 1) {
            this.goNext()
          }
        }

        return false
      },
      closeToolbox () {
        this.$emit('close')
      },
      goNext () {
        this.value.step = 2
      },
      clearQueue () {
        this.dropzone.removeAllFiles(true)
        this.dropzone.files = []
        this.dropzone.setupEventListeners()
        this.value.step = 1
      }
    },
    computed: {
      getDropZoneSettings () {
        let settings = this.dropzoneSettings
        settings.url = process.env.VUE_APP_API_ENDPOINT + 'import/analyze'
        settings.headers = { 'X-Session-Id': this.$store.getters['auth/getSessionId'] }
        settings.clickable = this.$refs.dropZoneElement
        settings.previewsContainer = this.$refs.dropZonePreviewContainer

        return settings
      },
      getItemStep () {
        return this.value.step
      }
    },
    watch: {
      getItemStep (newVal) {
        if (newVal === 1) {
          if (typeof this.dropzone !== 'undefined') {
            this.dropzone.setupEventListeners()
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>
